import { Alert, Chip, Paper, Stack, Typography } from "@mui/material";
import { useEffect, useState } from "react";
import { makeStyles, createStyles } from "@mui/styles";
import { useParams } from "react-router-dom";
import { getNews } from "../../api/news-api";
import { NewsPost } from "./types";
import ErrorPage from "../error/error";
import theme from "../../components/theme/theme";

const useStyles = makeStyles(() =>
  createStyles({
    card: {
      padding: "15px",
    },
  })
);

const paperElevation = 3;

export default function News() {
  const { customer } = useParams();

  const classes = useStyles(theme);
  const [result, setResult] = useState<{
    customer: string;
    posts?: NewsPost[];
    error?: string;
  }>();

  useEffect(() => {
    if (!customer) return;
    let active = true;
    setResult(undefined);
    getNews(customer).then(
      (posts) => active && setResult({ customer, posts }),
      () =>
        active &&
        setResult({
          customer,
          error: "Nyheterna kunde inte hämtas. Försök igen senare.",
        })
    );
    return () => {
      active = false;
    };
  }, [customer]);

  return customer ? (
    <Stack spacing={2}>
      <Typography variant="h1">Nyheter</Typography>
      {result?.customer !== customer && (
        <Typography role="status">Hämtar nyheter…</Typography>
      )}
      {result?.customer === customer && result.error && (
        <Alert severity="error">{result.error}</Alert>
      )}
      {result?.customer === customer && result.posts?.length === 0 && (
        <Typography>Inga nyheter ännu.</Typography>
      )}
      {(result?.customer === customer ? (result.posts ?? []) : []).map(
        (newsPost) => (
          <Paper
            className={classes.card}
            elevation={paperElevation}
            key={newsPost.id}
          >
            <Typography variant="h2" marginBottom={1}>
              <Chip
                label={new Date(newsPost.published).toLocaleDateString(
                  "sv-SE",
                  {
                    timeZone: "Europe/Stockholm",
                    day: "numeric",
                    month: "long",
                    year: "numeric",
                  }
                )}
                sx={{ marginRight: 2 }}
              />
              {newsPost.title}
            </Typography>
            <Typography
              paragraph
              variant="body1"
              sx={{ whiteSpace: "pre-line" }}
            >
              {newsPost.text}
            </Typography>
          </Paper>
        )
      )}
    </Stack>
  ) : (
    <ErrorPage error="Sidan hittades inte" />
  );
}
